import Box from '@mui/material/Box';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { OpenXAgentFeatureCard } from './OpenXAgentFeatureCard';
import { OpenXAgentGreetingCard } from './OpenXAgentGreetingCard';
import { getOpenXAgentTools } from './utils/consts';
import type { OpenXAgentTool, OpenXAgentToolConfig } from './utils/types';

type OpenXAgentHomeViewProps = {
  userName: string;
  onSelectTool: (toolId: OpenXAgentTool) => void;
  tools?: OpenXAgentToolConfig[];
};

export const OpenXAgentHomeView = ({ userName, onSelectTool, tools }: OpenXAgentHomeViewProps) => {
  const { t } = useTranslation();
  const defaultTools = useMemo(() => getOpenXAgentTools(t), [t]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, px: 3, py: 4 }}>
      <OpenXAgentGreetingCard userName={userName} />
      {(tools ?? defaultTools).map(tool => (
        <OpenXAgentFeatureCard key={tool.id} tool={tool} onSelectTool={onSelectTool} />
      ))}
    </Box>
  );
};
